import React, {useCallback, useEffect} from 'react';
import ViewDoubleInvoiceProperties from "./ViewDoubleInvoiceProperties";
import {Observer} from "mobx-react-lite";
import { Config } from '../../../../util/Config';
import DocumentViewer from '../../../../ui_components/DocumentViewer/DocumentViewer';

const ViewDoubleInvoice: React.FC<ViewDoubleInvoiceProperties> = ({
                                                                      productOrderId,
                                                                  }) => {
    const getInvoiceUrl = useCallback(() => {
        return Config.get("VIEW_RECEIPT_URL", {productOrderId, single: false});
    }, [productOrderId]);

    const [invoiceUrl, setInvoiceUrl] = React.useState(getInvoiceUrl());

    useEffect(() => {
        setInvoiceUrl(getInvoiceUrl());
    }, [productOrderId, getInvoiceUrl]);

    return <Observer>
        {() => (
            <>
                <DocumentViewer url={invoiceUrl}/>
            </>
        )}
    </Observer>
}

export default ViewDoubleInvoice;
